export const permissions = {
  admin: {
    adminControl: true,
    coupons: true,
    emails: true,
    sendEmail: true,
    news: true,
    payments: true,
    pricingTable: true,
    newPricingTable: true,
    regions: true,
    pushNotifications: true,
    sendPushNotifications: true,
    addEditDeleteEmailTemplate: true,
    addEditDeleteNotificationTemplate: true,
    reports: true,
    cleanerSSN: true,
    cleanerDocuments: true,
    cleanerServiceValue: true,
    cleanerEditAccess: true,
    SSNNumberAccess: true,
    mainCleanerEdit: true,
    propertyValue: true,
    cleanerServiceRates: true,
    propertyAccess: true,
    iCallAccess: true,
    scheduleButtonAccess: true,
    clientsAction: true,
    clientAddressAccess: true,
    upcomingSchedule: true,
    newRegionButton: true,
    newCityButton: true,
    newRegionalAdmin: true,
    accessClientNotification: true,
    noEditAccess: true,
    reportGeneralTab: true,
    dashboardCouponsManageButton: true,
    addEditDeleteCoupon: true,
    addEditDeletePricingTable: true,
    cleanerReportCategory: true,
    superVisorNoteAction: true,
    uploadCleanerDocument: true,
    revenueView: true,
    accessFinalAmount: true,
    selectRegion : true,
    hostTasks: true

  },
  director: {
    adminControl: true,
    coupons: true,
    emails: true,
    sendEmail: true,
    news: true,
    payments: true,
    pricingTable: true,
    newPricingTable: false,
    regions: true,
    pushNotifications: true,
    sendPushNotifications: true,
    addEditDeleteEmailTemplate: false,
    addEditDeleteNotificationTemplate: false,
    reports: true,
    cleanerSSN: true,
    cleanerDocuments: true,
    cleanerServiceValue: true,
    cleanerEditAccess: true,
    SSNNumberAccess: true,
    mainCleanerEdit: true,
    propertyValue: true,
    cleanerServiceRates: true,
    propertyAccess: true,
    iCallAccess: true,
    scheduleButtonAccess: true,
    clientsAction: true,
    clientAddressAccess: true,
    upcomingSchedule: true,
    newRegionButton: true,
    newCityButton: true,
    newRegionalAdmin: true,
    accessClientNotification: true,
    noEditAccess: true,
    reportGeneralTab: false,
    dashboardCouponsManageButton: true,
    addEditDeleteCoupon: false,
    addEditDeletePricingTable: false,
    cleanerReportCategory: false,
    superVisorNoteAction: true,
    uploadCleanerDocument: false,
    revenueView: false,
    accessFinalAmount: true,
    selectRegion : true,
    hostTasks: true
  },
  manager: {
    adminControl: true,
    coupons: true,
    emails: true,
    sendEmail: true,
    news: true,
    payments: false,
    pricingTable: true,
    newPricingTable: false,
    regions: true,
    pushNotifications: true,
    sendPushNotifications: true,
    addEditDeleteEmailTemplate: false,
    addEditDeleteNotificationTemplate: false,
    reports: true,
    cleanerSSN: false,
    cleanerDocuments: true,
    cleanerServiceValue: false,
    cleanerEditAccess: false,
    mainCleanerEdit: true,
    propertyValue: true,
    cleanerServiceRates: true,
    propertyAccess: true,
    SSNNumberAccess: true,
    iCallAccess: true,
    scheduleButtonAccess: true,
    clientsAction: true,
    clientAddressAccess: true,
    upcomingSchedule: true,
    newRegionButton: false,
    newCityButton: false,
    newRegionalAdmin: false,
    accessClientNotification: true,
    noEditAccess: true,
    reportGeneralTab: false,
    dashboardCouponsManageButton: true,
    addEditDeleteCoupon: false,
    addEditDeletePricingTable: false,
    cleanerReportCategory: false,
    superVisorNoteAction: true,
    uploadCleanerDocument: false,
    revenueView: false,
    accessFinalAmount: false,
    selectRegion : true,
    hostTasks: true
  },
  supervisor: {
    adminControl: false,
    coupons: false,
    emails: false,
    sendEmail: false,
    news: false,
    payments: false,
    pricingTable: false,
    newPricingTable: false,
    regions: false,
    pushNotifications: true,
    sendPushNotifications: true,
    addEditDeleteEmailTemplate: false,
    addEditDeleteNotificationTemplate: false,
    reports: true,
    cleanerSSN: false,
    cleanerDocuments: false,
    cleanerServiceValue: true,
    cleanerEditAccess: false,
    SSNNumberAccess: false,
    mainCleanerEdit: true,
    propertyValue: true,
    cleanerServiceRates: false,
    propertyAccess: true,
    iCallAccess: false,
    scheduleButtonAccess: true,
    clientsAction: false,
    clientAddressAccess: false,
    upcomingSchedule: true,
    newRegionButton: true,
    newCityButton: true,
    newRegionalAdmin: true,
    accessClientNotification: false,
    noEditAccess: true,
    reportGeneralTab: false,
    dashboardCouponsManageButton: false,
    addEditDeleteCoupon: false,
    addEditDeletePricingTable: false,
    cleanerReportCategory: false,
    superVisorNoteAction: true,
    uploadCleanerDocument: false,
    revenueView: false,
    accessFinalAmount: false,
    selectRegion : false,
    hostTasks: false
  },
  officer: {
    adminControl: false,
    coupons: false,
    emails: true,
    sendEmail: true,
    news: true,
    payments: true,
    pricingTable: true,
    newPricingTable: false,
    regions: true,
    pushNotifications: false,
    sendPushNotifications: false,
    addEditDeleteEmailTemplate: false,
    addEditDeleteNotificationTemplate: false,
    reports: true,
    cleanerSSN: true,
    cleanerDocuments: true,
    cleanerServiceValue: false,
    cleanerEditAccess: true,
    SSNNumberAccess: true,
    mainCleanerEdit: false,
    propertyValue: false,
    cleanerServiceRates: true,
    propertyAccess: false,
    iCallAccess: false,
    scheduleButtonAccess: false,
    clientsAction: false,
    clientAddressAccess: true,
    upcomingSchedule: false,
    newRegionButton: false,
    newCityButton: true,
    newRegionalAdmin: false,
    accessClientNotification: true,
    noEditAccess: false,
    reportGeneralTab: false,
    dashboardCouponsManageButton: false,
    addEditDeleteCoupon: false,
    addEditDeletePricingTable: false,
    cleanerReportCategory: false,
    superVisorNoteAction: true,
    uploadCleanerDocument: true,
    revenueView: false,
    accessFinalAmount: true,
    selectRegion : false,
    hostTasks: false
  }
}
